<template>
    <transactions-list ref="list" :data-func="getTransactions" :show-user="true" :min-amount-filter="3000000"/>
</template>
<script>
  import transactionService from '../../../services/transaction.service'

  import transactionsList from '../../common/transactions-list.vue'

  export default {
    name: 'client-trans-bets',
    components: { transactionsList },
    computed: {
      clientId() {
        return Number(this.$route.params.clientId);
      }
    },
    methods: {
      refresh() {
        this.$refs.list.reset();
      },
      async getTransactions(filter) {
        filter.clientId = this.clientId;
        return await transactionService.get(filter);
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/warn-transactions.vue